import { useEffect, useRef } from 'react';

import './wordExport.css';

const WordExportProgressOverlay = ({ isOpen }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousActiveElement = document.activeElement;
    const previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    overlayRef.current?.focus();

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      previousActiveElement?.focus?.();
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const keepFocusInsideOverlay = (event) => {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.preventDefault();
    }
  };

  return (
    <div
      ref={overlayRef}
      className="word-export-progress-overlay"
      role="dialog"
      aria-modal="true"
      aria-busy="true"
      aria-labelledby="word-export-progress-title"
      aria-describedby="word-export-progress-description"
      tabIndex={-1}
      onKeyDown={keepFocusInsideOverlay}
    >
      <div className="word-export-progress-card">
        <div className="word-export-progress-spinner" aria-hidden="true">
          <span />
        </div>
        <h2 id="word-export-progress-title">
          Формируем Word-документ
        </h2>
        <p
          id="word-export-progress-description"
          role="status"
          aria-live="polite"
        >
          Подготавливаем имя файла и содержимое заключения
        </p>
        <div className="word-export-progress-line" aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  );
};

export default WordExportProgressOverlay;
